import { IFormGroupChild } from '../../formGroup/types/form-group-children';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/**
 * A simple utility class that allows for hardcoded values to be inserted in a form-group
 * without creating an actual (hidden) form-field
 */
export class GzHardCodedFormField<T = unknown> implements IFormGroupChild<T> {
  public disabled: boolean;
  public readonly: boolean;

  protected validSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public valid$ = this.validSubject.pipe(distinctUntilChanged());

  constructor(public value: T) {}

  public get valid() {
    return this.validSubject.value;
  }

  public setValue(value: T) {
    this.value = value;
  }

  public validate(): void {
    // noop
  }

  public get hasUnsavedChanges(): boolean {
    // it's a hardcoded value, no need to track changes
    return false;
  }

  public refreshInitialFormValue(): void {
    // noop
  }

  public discardChanges(): void {
    // noop
  }
}
